
        var result = require("!!../../../../node_modules/css-loader/index.js!./management-quickview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/quickview/management-quickview.component.css
// module id = 2489
// module chunks = 1